import isEmpty from 'lodash/isEmpty';
import { EmailPattern } from '../../constants/createSegment';
import { Frequency, INVALID_DATE } from '../../enums/schedulingConstant';
import { stringFormatter } from '../commonUtils';

export const buildSegmentListOption = (segmentList = []) => {
  return segmentList?.reduce((acc, cur) => {
    const obj = {
      name: cur.segmentIdentifier.segmentName,
      id: cur.segmentIdentifier.segmentId,
      description: cur.segmentIdentifier.segmentDescription,
      createdBy: cur.createdBy,
    };
    acc.push(obj);
    return acc;
  }, []);
};

export const buildTemplateListOption = (templateList = []) => {
  return templateList?.reduce((acc, cur) => {
    const obj = {
      name: cur.messageTemplateName,
      id: cur.messageTemplateName,
      createdBy: cur.createdBy,
    };
    acc.push(obj);
    return acc;
  }, []);
};

export const segmentListFilter = (searchText, list = []) => {
  if (isEmpty(list)) return [];
  return list?.filter(el =>
    el.name
      ?.trim()
      .toLowerCase()
      .includes(searchText?.trim()?.toLowerCase()),
  );
};

export const templateListFilter = (searchText, list = []) => {
  if (isEmpty(list)) return [];
  return list?.filter(el =>
    el.name
      ?.trim()
      .toLowerCase()
      .includes(searchText?.trim()?.toLowerCase()),
  );
};

export const campaignDateBuilder = date => {
  if (date === undefined) return '';
  const [dateString, timeString] = date?.split('T');
  const [time] = timeString?.split('.');
  const result = dateString + 'T' + time + timezoneOffset();
  return result;
};

export const timezoneOffset = () => {
  const pad = function(num) {
    return (num < 10 ? '0' : '') + num;
  };
  const tzOffset = -new Date().getTimezoneOffset();
  const diff = tzOffset > 0 ? '+' : '-';

  const offset = new Date().getTimezoneOffset();
  if (offset === 0) return '00:00';
  const hours = pad(Math.floor(Math.abs(offset) / 60));
  const minutes = pad(Math.floor(Math.abs(offset) % 60));
  const result = `${diff}${hours}:${minutes}`;
  return result;
};

export const validateEmail = address => {
  if (isEmpty(address)) return false;
  return EmailPattern.test(address);
};

export const dateFormatter = dateString => {
  if (isEmpty(dateString)) return '-';
  if (dateString === Frequency.IMMEDIATE) return Frequency.IMMEDIATE;
  const parsedDate = new Date(dateString);
  if (parsedDate === undefined || parsedDate?.toString() === INVALID_DATE) return '-';
  const parsedDateString = parsedDate?.toDateString();
  const [timeString] = parsedDate.toTimeString()?.split(' ');
  return `${parsedDateString} ${timeString}`;
};

/**
 * Formats getAllCampaigns response into tabular form
 */

export const campaignListFormatter = list => {
  if (!Array.isArray(list)) {
    return [];
  }
  return list?.map(campaign => {
    const formattedCampaign = { ...campaign };
    const { lastModifiedDate } = formattedCampaign;
    Object.keys(formattedCampaign)?.map(key => {
      if (typeof formattedCampaign[key] === 'string') {
        formattedCampaign[key] = stringFormatter(formattedCampaign[key]);
      }
    });
    formattedCampaign.lastModifiedDate = new Date(lastModifiedDate).toUTCString();
    return formattedCampaign;
  });
};

export default campaignListFormatter;
